import { CustomElement } from '@aurelia/runtime-html';
export const name = "duration-input";
export const template = "<template>\n  <div class=\"input-group duration-input\" style=\"max-width: 9rem\">\n    <select class=\"form-control\" id.to-view=\"idvalue\" value.bind=\"hours\">\n      <option repeat.for=\"option of hourOptions\" model.bind=\"option.value\">${option.label}</option>\n    </select>\n    <div class=\"input-group-prepend input-group-append\">\n      <span class=\"input-group-text\">:</span>\n    </div>\n    <select class=\"form-control\" value.bind=\"minutesPart\">\n      <option repeat.for=\"option of minuteOptions\" model.bind=\"option.value\">${option.label}</option>\n    </select>\n  </div>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
